import { BmiCalculator, BmiCalculatorDefaultProps } from "../../BMICalculator/BMICalculator";
import { jsx as _jsx } from "react/jsx-runtime";
export var BmiCalculatorSlice = function BmiCalculatorSlice(_ref) {
  var _ref$title = _ref.title,
    title = _ref$title === void 0 ? BmiCalculatorDefaultProps.title : _ref$title,
    _ref$units = _ref.units,
    units = _ref$units === void 0 ? BmiCalculatorDefaultProps.units : _ref$units,
    _ref$bmiEmpty = _ref.bmiEmpty,
    bmiEmpty = _ref$bmiEmpty === void 0 ? BmiCalculatorDefaultProps.bmiEmpty : _ref$bmiEmpty,
    _ref$accessibility = _ref.accessibility,
    accessibility = _ref$accessibility === void 0 ? BmiCalculatorDefaultProps.accessibility : _ref$accessibility,
    _ref$unitLabels = _ref.unitLabels,
    unitLabels = _ref$unitLabels === void 0 ? BmiCalculatorDefaultProps.unitLabels : _ref$unitLabels,
    _ref$weightLabel = _ref.weightLabel,
    weightLabel = _ref$weightLabel === void 0 ? BmiCalculatorDefaultProps.weightLabel : _ref$weightLabel,
    _ref$heightLabel = _ref.heightLabel,
    heightLabel = _ref$heightLabel === void 0 ? BmiCalculatorDefaultProps.heightLabel : _ref$heightLabel,
    _ref$valueLabel = _ref.valueLabel,
    valueLabel = _ref$valueLabel === void 0 ? BmiCalculatorDefaultProps.valueLabel : _ref$valueLabel;
  return /*#__PURE__*/_jsx(BmiCalculator, {
    title: title,
    units: units,
    bmiEmpty: bmiEmpty,
    accessibility: accessibility,
    unitLabels: unitLabels,
    weightLabel: weightLabel,
    heightLabel: heightLabel,
    valueLabel: valueLabel
  });
};